import { render, staticRenderFns } from "./MembresiasDentalia.vue?vue&type=template&id=374dfbf6&scoped=true"
import script from "./MembresiasDentalia.vue?vue&type=script&lang=js"
export * from "./MembresiasDentalia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374dfbf6",
  null
  
)

export default component.exports